import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { ConfirmApprovalModalComponent } from '../confirm-approval-modal/confirm-approval-modal.component';

@Component({
  selector: 'app-add-notes-modal',
  templateUrl: './add-notes-modal.component.html',
  styleUrls: ['./add-notes-modal.component.scss']
})
export class AddNotesModalComponent {

  public data: any;
  endPoint: any;
  payload: any;
  approvalForm!: FormGroup;
  submitted =false;
  isCommentBoxShow =false

  constructor(private fb: FormBuilder, private api: SevaProfileService, protected dialogRef: NbDialogRef<ConfirmApprovalModalComponent>) {
    this.data = this.dialogRef;
  }

  ngOnInit() {
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
    this.isCommentBoxShow = this.data.isCommentBoxShow; // Assuming this field is provided in data
  
    this.initializeForm();
  }
  
  initializeForm() {
    const commentValidators = this.isCommentBoxShow ? [] : [Validators.required]; // Apply validation conditionally
    this.approvalForm = this.fb.group({
      comment: ['', commentValidators],
    });
  }
  
  approve() {
    if (!this.isCommentBoxShow && this.approvalForm.invalid) {
      this.submitted = true;
      this.approvalForm.markAllAsTouched(); // Highlight invalid fields
      return;
    }
  
    this.submitted = false;
  
    if (!this.isCommentBoxShow) {
      const comment = this.approvalForm.get('comment')?.value;
      this.payload.Notes = comment;
    }
  
    this.api.apiCall(this.endPoint, 'POST', this.payload).subscribe((response: any) => {
      if (response.Data) {
        this.dialogRef.close(true); // Pass true to indicate approval
      }
    });
  }
  

  cancel() {
    this.dialogRef.close(false); // Pass false to indicate cancellation
  }
}
